var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ReturnController = /** @class */ (function (_super) {
    __extends(ReturnController, _super);
    function ReturnController() {
        this.type = 'return';
        return _super !== null && _super.apply(this, arguments) || this;
    }

    /**
     * Show thanks message
     * @param {MouseEvent} $event
     * @returns {angular.IPromise<any>}
     */
    ReturnController.prototype.showAskUserConnectToChargingStationModal = function ($event) {
        return this.$mdDialog.show(this.$mdDialog.alert()
            .clickOutsideToClose(true)
            .textContent(this.$translationService.getTranslation('PlsConnectVehicleAndCharge'))
            .ok(this.$translationService.getTranslation('OK'))
            .targetEvent($event));
    };
    /**
     * Save booking
     * @param data {IPickUpReturnSave}
     * @param {MouseEvent} $event
     */
    ReturnController.prototype.save = function (data, $event) {
        this.vehicleBookingService.returnBooking(data)
            .then(() => {
                //Show thanks message if the vehicle is electric vehicle
                if (this.vehicleBookingService.isElectricVehicle(this.vehicleBooking.VehiclePropulsion)) {
                    this.showAskUserConnectToChargingStationModal($event).then( ()=> {
                        this.afterPickupReturnComplete();
                    });
                }
                else {
                    this.afterPickupReturnComplete();
                }
            }, (error) => {
                this.showConnectErrorMessage(error);
            })
            .finally(this.$Loading.blockUI({
                title: "Saving"
            }));
    };


    return ReturnController;
}(PickupController));
angular.module('internal.vehiclebookings').controller('ReturnController', ReturnController);
